import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Link } from 'react-router-dom';

const faqs = [
  {
    question: 'How does GiriChat work?',
    answer: 'GiriChat is a WhatsApp Business API platform that allows you to send bulk messages, automate conversations, and track campaign performance. Simply sign up, connect your Meta Business account, and start messaging.',
  },
  {
    question: 'Is GiriChat compliant with WhatsApp policies?',
    answer: 'Yes, GiriChat is fully compliant with WhatsApp Business API policies and Meta Developer Policies. We follow all guidelines to ensure your account remains in good standing.',
  },
  {
    question: 'How do I connect my WhatsApp Business account?',
    answer: 'You can connect your WhatsApp Business account by clicking "Continue with Facebook" on our signup page. This will guide you through Meta\'s verification process to set up your WhatsApp Business API.',
  },
  {
    question: 'What kind of support do you offer?',
    answer: 'We provide email support for all plans, with priority support for Professional and Enterprise customers. Enterprise customers also get a dedicated account manager for personalized assistance.',
  },
  {
    question: 'Do I need to get my customers\' consent?',
    answer: 'Yes, you must obtain explicit, verifiable consent (opt-in) from all recipients before sending business-initiated messages. You must also honor all opt-out requests immediately.',
  },
  {
    question: 'What happens if I violate Meta\'s policies?',
    answer: 'If you violate Meta\'s policies, your account may be suspended by Meta. GiriChat is not responsible for any suspension due to policy violations. Please review our Terms of Service for details.',
  },
  {
    question: 'Can I cancel my subscription anytime?',
    answer: 'Yes, you can cancel your subscription at any time with no questions asked. There are no long-term contracts or cancellation fees.',
  },
  {
    question: 'Is my data secure?',
    answer: 'Absolutely. We use industry-standard encryption (AES-256) for data at rest and HTTPS for data in transit. We are GDPR compliant and never sell your data to third parties.',
  },
];

export function FAQ() {
  return (
    <div className="bg-white py-12 sm:py-16 lg:py-20 px-4" id="faq" data-testid="faq-section">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            Frequently asked questions
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600">
            Everything you need to know about GiriChat
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-3 sm:space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="border border-gray-200 rounded-lg px-4 sm:px-6 bg-white"
            >
              <AccordionTrigger className="text-left text-sm sm:text-base text-gray-900 hover:no-underline py-3 sm:py-4 font-medium">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-gray-600 pb-3 sm:pb-4">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="mt-8 sm:mt-12 text-center bg-gray-50 rounded-lg p-6 sm:p-8 border border-gray-200">
          <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">Still have questions?</h3>
          <p className="text-sm sm:text-base text-gray-600 mb-4">
            Can't find the answer you're looking for? Our support team is here to help.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 text-[#00D95F] hover:underline font-semibold text-sm sm:text-base"
          >
            Contact Support →
          </Link>
        </div>
      </div>
    </div>
  );
}
